<template>
    <v-autocomplete
      v-bind="$attrs"
      item-text="name"
      item-value="id_doc"
      :items="list"
      :label="label"
      :disabled="isLoadingData || $attrs.disabled"
      :loading="isLoadingData || $attrs.loading"
      persistent-hint
      :rules="rules"
      v-model="selectedItem"
      @change="selectItem"
    />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ResponsibleTypeService from "@/services/firebase/ResponsibleType/ResponsibleTypeService";

export default {
  props:{
    id_responsible_type: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    label: "Tipo",
    list: [],
    selectedItem: null,
    selectedItemProp: null,
    isLoadingData: true,
  }),

  computed: {
    ...mapGetters(["getFranqueados", "getCurrentUser", "getCurrentUserRank"]),
   
  },

  methods: {
    ...mapActions(["getClientsBy"]),
    selectItem() {
      if( this.selectedItem ) this.$emit('id', this.selectedItem)
      else this.$emit('id', null)
    },
  },

  watch: {
    id_responsible_type:  {
      immediate: true,
      handler: function (newValue) {
        this.selectedItem = newValue
      }
    },
  },

  async created() {
    this.list = await ResponsibleTypeService.getResponsibleTypes()
    this.isLoadingData = false
  }     
};
</script>


<style>
</style>